import common from 'common';

if (LIMI_ENV === 'electron') {
  var fs = window.require('fs');
}
//是否为移动端
const detectmob = () => {
  let u = navigator.userAgent;
  if (
    u.match(/Android/i) ||
    u.match(/webOS/i) ||
    u.match(/iPhone/i) ||
    u.match(/iPad/i) ||
    u.match(/iPod/i) ||
    u.match(/BlackBerry/i) ||
    u.match(/Windows Phone/i) ||
    u.match(/windows mobile/i) ||
    u.match(/windows ce/i) ||
    u.match(/ucweb/i) ||
    u.match(/rv:1.2.3.4/i) ||
    u.match(/midp/i)
  ) {
    return true;
  } else {
    return false;
  }
};
//判断浏览器为何种内核
const browserCoreFn = () => {
  let u;
  let user = navigator.userAgent;
  if (!!user.match(/AppleWebKit/) || !!user.match(/gecko/gi)) {
    u = navigator.userAgent;
  } else {
    u = navigator.appVersion;
  }

  // 360浏览器全面检测
  const detect360Browser = () => {
    const userAgent = navigator.userAgent.toLowerCase();

    // 检测各种360浏览器标识
    const patterns360 = [
      '360se', // 360安全浏览器
      '360ee', // 360极速浏览器
      '360安全浏览器', // 中文标识
      '360极速浏览器', // 中文标识
      'qihu 360', // 奇虎360
      '360browser', // 通用标识
      'qihoobrower', // 可能的拼写错误
      'qihoo browser', // 另一种写法
      'qhbrowser', // 简写
      '360chrome', // 360版Chrome
    ];

    // UA字符串检测
    for (let pattern of patterns360) {
      if (userAgent.indexOf(pattern) > -1) {
        return true;
      }
    }

    // 检测360浏览器特有对象（如果可以访问）
    try {
      if (window.external) {
        const external360Methods = [
          'twGetRunPath',
          'twGetVersion',
          'twGetSecurityID',
          'ullEnableWebPageClip',
          'setHomePage',
          'AddToFavoritesBar',
        ];

        for (let method of external360Methods) {
          if (window.external[method]) {
            return true;
          }
        }
      }
    } catch (e) {
      // 忽略访问错误
    }

    // 检测window上的360相关属性
    try {
      const window360Props = [
        'QHPass',
        'QihuBrowser',
        'Browser360',
        'external360',
        'qihu360',
        '__360BrowserDetect',
      ];

      for (let prop of window360Props) {
        if (window[prop]) {
          return true;
        }
      }
    } catch (e) {
      // 忽略错误
    }

    return false;
  };

  return {
    AppleWebKit: !!u.match(/AppleWebKit/gi),
    trident: u.indexOf('Trident') > -1, //IE内核
    presto: u.indexOf('Presto') > -1, //opera内核
    gecko: !!u.match(/gecko/gi), //火狐和chrome，360 qq用的都是这个内核
    Firefox: !!u.match(/Firefox/gi), //火狐内核Gecko
    Edge: !!u.match(/(Edge)/gi), //Edge浏览器
    Chrome: !!u.match(/(Chrome)/gi),
    Safari: !!u.match(/(Safari)/gi),
    bro_360SE: detect360Browser(), // 升级版360检测
    bro_qq: !!u.match(/QQBrowser/gi),
  };
};
//=>是否具有webSocket
const hasWebSocket = () => {
  return !!window.WebSocket && 'WebSocket' in window;
};

//浏览器是否支持
const browserReachLevel = () => {
  let browserCore = browserCoreFn();

  // 检测360浏览器，如果是360浏览器直接返回不支持
  if (browserCore.bro_360SE) {
    return true; // 返回true表示不支持
  }

  let broswer =
    browserCore.AppleWebKit &&
    browserCore.gecko &&
    browserCore.Chrome &&
    browserCore.Safari &&
    !browserCore.Edge;
  if (broswer && hasWebSocket()) {
    return false;
  } else {
    return true;
  }
};
//获取可视高度
const getClientHeight = () => document.body.clientHeight;
//获取可视宽度
const getClientWidth = () => document.body.clientWidth;
const getScreenInfomation = () => {
  return {
    usableRatio: document.body.clientWidth + '*' + document.body.clientHeight,
    screenRatio: window.screen.width + '*' + window.screen.height,
  };
};
//获取元素样式兼容处理
const getElementStyle = (obj, attr) => {
  if (obj.currentStyle) {
    return obj.currentStyle[attr];
  } else {
    return getComputedStyle(obj, false)[attr]; //第二个参数是伪类
  }
};

//把秒格式化为00:00:00
const formate_seconds = (second) => {
  second = Math.round(second);
  let minute = 0;
  let hour = 0;
  if (second >= 60) {
    minute = parseInt(second / 60);
    second = parseInt(second % 60);
    if (minute >= 60) {
      hour = parseInt(minute / 60);
      minute = parseInt(minute % 60);
    }
  }
  let time = '';
  //=>只有秒存在
  if (minute == 0) {
    time +=
      second.toString().length === 2
        ? '00:' + parseInt(second)
        : '00:0' + parseInt(second);
  } else {
    //=>处理second为两位
    if (second.toString().length === 2) {
      time += parseInt(second);
    } else {
      //处理second为一位
      time += '0' + parseInt(second);
    }
  }
  if (minute != 0) {
    time =
      minute.toString().length === 2
        ? parseInt(minute) + ':' + time
        : '0' + parseInt(minute) + ':' + time;
  }
  if (hour != 0) {
    time =
      hour.toString().length === 2
        ? parseInt(hour) + ':' + time
        : '0' + parseInt(hour) + ':' + time;
  }
  return time;
};

const dateFormat = (fmt, date) => {
  let ret;
  let opt = {
    'Y+': date.getFullYear().toString(), // 年
    'm+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'H+': date.getHours().toString(), // 时
    'M+': date.getMinutes().toString(), // 分
    'S+': date.getSeconds().toString(), // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt);
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'),
      );
    }
  }
  return fmt;
};
//生成设备唯一标识
const createDeviceId = () => {
  //生成设备唯一标识  uid_时间戳(精确到微秒)_随机字符(5位)
  let deviceid = common.getSession('random_deviceid');
  if (!deviceid) {
    let uid = common.getSession('userID');
    let time = Date.now();
    let num = Math.floor(Math.random() * 100000);
    num = num < 10000 ? 10000 + num : num;
    deviceid = uid + '_' + time + '_' + num;
    common.setSession('random_deviceid', deviceid);
  }
  return deviceid;
};

//获取浏览器信息
const getBrowserVersion = () => {
  var agent = navigator.userAgent.toLowerCase();
  var str = '';
  var Browser = '';
  var Bversion = '';
  var verinNum = ''; //IE
  if (agent.indexOf('msie') > 0) {
    var regStr_ie = /msie [\d.]+;/gi;
    Browser = 'IE';
    Bversion = '' + agent.match(regStr_ie);
  } else if (agent.indexOf('firefox') > 0) {
    //firefox
    var regStr_ff = /firefox\/[\d.]+/gi;
    Browser = 'firefox';
    Bversion = '' + agent.match(regStr_ff);
  } else if (agent.indexOf('chrome') > 0) {
    //Chrome
    var regStr_chrome = /chrome\/[\d.]+/gi;
    Browser = 'chrome';
    Bversion = '' + agent.match(regStr_chrome);
  } else if (agent.indexOf('safari') > 0 && agent.indexOf('chrome') < 0) {
    //Safari
    var regStr_saf = /version\/[\d.]+/gi;
    Browser = 'safari';
    Bversion = '' + agent.match(regStr_saf);
  } else if (agent.indexOf('opera') >= 0) {
    //Opera
    var regStr_opera = /version\/[\d.]+/gi;
    Browser = 'opera';
    Bversion = '' + agent.match(regStr_opera);
  } else {
    var browser = navigator.appName;
    if (browser == 'Netscape') {
      var version = agent.split(';');
      var trim_Version = version[7].replace(/[ ]/g, '');
      var rvStr = trim_Version.match(/[\d\.]/g).toString();
      var rv = rvStr.replace(/[,]/g, '');
      Bversion = rv;
      Browser = 'IE';
    }
  }
  verinNum = (Bversion + '').replace(/[^0-9.]/gi, '');
  str = Browser + ' ' + verinNum;
  return str;
};
//获取系统信息
const getSystemInfo = () => {
  var sUserAgent = navigator.userAgent;
  var isWin = navigator.platform == 'Win32' || navigator.platform == 'Windows';
  var isMac =
    navigator.platform == 'Mac68K' ||
    navigator.platform == 'MacPPC' ||
    navigator.platform == 'Macintosh' ||
    navigator.platform == 'MacIntel';
  if (isMac) return 'Mac';
  var isUnix = navigator.platform == 'X11' && !isWin && !isMac;
  if (isUnix) return 'Unix';
  var isLinux = String(navigator.platform).indexOf('Linux') > -1;
  if (isLinux) return 'Linux';
  if (isWin) {
    var isWin2K =
      sUserAgent.indexOf('Windows NT 5.0') > -1 ||
      sUserAgent.indexOf('Windows 2000') > -1;
    if (isWin2K) return 'Win2000';
    var isWinXP =
      sUserAgent.indexOf('Windows NT 5.1') > -1 ||
      sUserAgent.indexOf('Windows XP') > -1;
    if (isWinXP) return 'WinXP';
    var isWin2003 =
      sUserAgent.indexOf('Windows NT 5.2') > -1 ||
      sUserAgent.indexOf('Windows 2003') > -1;
    if (isWin2003) return 'Win2003';
    var isWinVista =
      sUserAgent.indexOf('Windows NT 6.0') > -1 ||
      sUserAgent.indexOf('Windows Vista') > -1;
    if (isWinVista) return 'WinVista';
    var isWin7 =
      sUserAgent.indexOf('Windows NT 6.1') > -1 ||
      sUserAgent.indexOf('Windows 7') > -1;
    if (isWin7) return 'Win7';
    var isWin10 =
      sUserAgent.indexOf('Windows NT 10') > -1 ||
      sUserAgent.indexOf('Windows 10') > -1;
    if (isWin10) return 'Win10';
  }
  return 'other';
};
//生成unique_id
const createUniqueId = (type) => {
  let uid = common.getSession('userID');
  let time = Date.now();
  let num = Math.floor(Math.random() * 100000);
  num = num < 10000 ? 10000 + num : num;
  let uniqueId = uid + '_' + time + '_' + num;
  type && common.setSession(type, uniqueId);
  return uniqueId;
};
//过滤函数
const messageFilter = (unique_id, type) => {
  let filterData = common.get('filterData') || {};
  const lesson_id = common.getSession('lesson_id');
  if (!filterData[lesson_id]) {
    filterData[lesson_id] = {
      time: common.getTemServerTime(),
      msgList: [],
      displayList: [],
      ackList: [],
    };
  }
  if (!filterData[lesson_id][type]) filterData[lesson_id][type] = [];
  let dataArr = filterData[lesson_id][type];
  //长连接消息过滤函数
  if (dataArr.indexOf(unique_id) > -1) {
    //
    return false;
  } else {
    //
    if (dataArr.length >= 800) dataArr.length = 800;
    dataArr.unshift(unique_id);
    common.set('filterData', filterData);
    return true;
  }
};

//清除过滤池
const clearMessageFilterData = (time) => {
  let filterData = common.get('filterData') || {};
  let cstime = 60 * 60 * 24; //三小时
  for (let item in filterData) {
    if (time - filterData[item].time > cstime) {
      delete filterData[item];
      common.set('filterData', filterData);
    }
  }
};
//获取字符长度
const realLength = (val) => {
  let v = val + '';
  return v.replace(/[^\x00-\xff]/g, '**').length; // [^\x00-\xff] - 匹配非双字节的字符
};

const setNodeStorge = (key, value) => {
  let fileData;
  try {
    fileData = JSON.parse(fs.readFileSync(nodeProcess.cwd() + '/confing.json'));
  } catch (error) {
    fs.writeFileSync(
      //创建配置文件
      nodeProcess.cwd() + '/confing.json',
      JSON.stringify({}),
    );
    fileData = JSON.parse(fs.readFileSync(nodeProcess.cwd() + '/confing.json'));
  }
  fileData[key] = value;
  fs.writeFileSync(
    nodeProcess.cwd() + '/confing.json',
    JSON.stringify(fileData),
  );
};
const getNodeStorge = (key) => {
  let fileData;
  if (!fs.existsSync(nodeProcess.cwd() + '/confing.json')) {
    return false;
  } else {
    try {
      fileData = JSON.parse(
        fs.readFileSync(nodeProcess.cwd() + '/confing.json'),
      );
    } catch (error) {
      fs.writeFileSync(
        //创建配置文件
        nodeProcess.cwd() + '/confing.json',
        JSON.stringify({}),
      );
      fileData = JSON.parse(
        fs.readFileSync(nodeProcess.cwd() + '/confing.json'),
      );
    }
    return fileData[key];
  }
};
const removeStorge = (key) => {
  if (!fs.existsSync(nodeProcess.cwd() + '/confing.json')) {
    return false;
  } else {
    let fileData = JSON.parse(
      fs.readFileSync(nodeProcess.cwd() + '/confing.json'),
    );
    if (Reflect.deleteProperty(fileData, key)) {
      try {
        fs.writeFileSync(
          nodeProcess.cwd() + '/confing.json',
          JSON.stringify(fileData),
        );
      } catch (e) {}
    } else {
      return false;
    }
  }
};
//获取内网ip
const getLANIP = (callback = () => {}) => {
  let recode = {};
  let RTCPeerConnection =
    window.RTCPeerConnection ||
    window.mozRTCPeerConnection ||
    window.webkitRTCPeerConnection;
  // 如果不存在则使用一个iframe绕过
  if (!RTCPeerConnection) {
    // 因为这里用到了iframe，所以在调用这个方法的script上必须有一个iframe标签
    // <iframe id="iframe" sandbox="allow-same-origin" style="display:none;"></iframe>
    let win = iframe.contentWindow;
    RTCPeerConnection =
      win.RTCPeerConnection ||
      win.mozRTCPeerConnection ||
      win.webkitRTCPeerConnection;
  }

  //创建实例，生成连接
  let pc = new RTCPeerConnection();

  // 匹配字符串中符合ip地址的字段
  function handleCandidate(candidate) {
    let ip_regexp =
      /([0-9]{1,3}(\.[0-9]{1,3}){3}|([a-f0-9]{1,4}((:[a-f0-9]{1,4}){7}|:+[a-f0-9]{1,4}){6}))/;
    let ip_isMatch = candidate.match(ip_regexp);
    ip_isMatch = ip_isMatch ? ip_isMatch[1] : '';
    if (!recode[ip_isMatch]) {
      callback(ip_isMatch);
      common.LANIP = ip_isMatch;
      recode[ip_isMatch] = true;
    }
  }

  //监听icecandidate事件
  pc.onicecandidate = (ice) => {
    if (ice.candidate) {
      handleCandidate(ice.candidate.candidate);
    }
  };
  //建立一个伪数据的通道
  pc.createDataChannel('');
  pc.createOffer(
    (res) => {
      pc.setLocalDescription(res);
    },
    () => {},
  );

  //延迟，让一切都能完成
  setTimeout(() => {
    try {
      let lines = pc.localDescription.sdp.split('\n');
      lines.forEach((item) => {
        if (item.indexOf('a=candidate:') === 0) {
          handleCandidate(item);
        }
      });
    } catch (error) {}
  }, 1000);
};
//是否是safari浏览器
const issafariBrowser = () => {
  return (
    /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)
  );
};
//截图 -video标签
const screenshotsVideo = () => {
  let canvas = document.createElement('canvas');
  let video = document.getElementsByTagName('video')[0];
  let cWidth = video.videoWidth || 1280;
  let cHeight = video.videoHeight || 720;
  canvas.width = cWidth;
  canvas.height = cHeight;
  canvas.getContext('2d').drawImage(video, 0, 0, cWidth, cHeight);
  let url = canvas.toDataURL('image/jpeg');
  canvas = null;
  return url;
};
//web下载截图
const downloadScreenshotsWeb = (
  url = screenshotsVideo(),
  filename = Date.now() + '.jpeg',
) => {
  let a = document.createElement('a');
  a.href = url;
  a.download = filename;
  let ev = document.createEvent('MouseEvents');
  ev.initMouseEvent(
    'click',
    true,
    false,
    window,
    0,
    0,
    0,
    0,
    0,
    false,
    false,
    false,
    false,
    0,
    null,
  );
  a.dispatchEvent(ev);
  a = null;
  ev = null;
};
const mkScreenshotsDir = () => {
  const fs = window.require('fs');
  const screenshotPath =
    window.require('os').userInfo().homedir + '\\Desktop\\名师火箭班截图笔记\\';
  if (!fs.existsSync(screenshotPath)) {
    fs.mkdirSync(screenshotPath);
  }
  return screenshotPath;
};
const screenshotsPc = (
  callback = () => {},
  filename = Date.now() + '.jpeg',
) => {
  if (LIMI_ENV === 'electron') {
    const fs = window.require('fs');
    const path = window.require('path');
    const screenshotPath = mkScreenshotsDir();
    const base64Data = screenshotsVideo().replace(
      /^data:image\/\w+;base64,/,
      '',
    );
    const dataBuffer = new Buffer(base64Data, 'base64');
    fs.writeFile(path.join(screenshotPath, filename), dataBuffer, (err) => {
      if (err) {
        callback('error');
        return;
      }
      callback('success');
    });
  }
};
const setVideoWH = (topH) => {
  const winHeight = document.body.clientHeight - topH; // 可视区高度减去头部底部
  const w = document.body.clientWidth;
  const winWidth = w < 1258 ? 1258 : w;
  let videoW = 0;
  let videoH = 0;
  if (winWidth / winHeight > 16 / 9) {
    videoH = winHeight;
    videoW = Math.ceil((16 / 9) * videoH);
  } else {
    videoW = winWidth;
    videoH = Math.ceil(videoW * (9 / 16));
  }
  return {
    w: videoW,
    h: videoH,
  };
};
const loadImage = (src, loadNum = 0) => {
  let image = new Image();
  let interval = null;
  image.src = src;
  let num = 0;
  const p = new Promise((resolve) => {
    if (!src) {
      image = null;
      resolve();
      return;
    }
    const loadAgain = () => {
      clearTimeout(interval);
      if (num < loadNum) {
        image.src = '';
        image.src = src;
        num++;
      } else {
        image = null;
        resolve();
      }
    };
    image.onload = () => {
      resolve();
      clearTimeout(interval);
    };
    image.onerror = loadAgain;
    interval = setTimeout(loadAgain, 3000);
  });
  return p.then(() => {
    return image;
  });
};
const createLoginDeviceId = (phone) => {
  //生成设备唯一标识  uid_时间戳(精确到微秒)_随机字符(5位)
  let deviceid = common.get('login_deviceid');
  if (!deviceid) {
    let time = Date.now();
    let num = Math.floor(Math.random() * 100000);
    num = num < 10000 ? 10000 + num : num;
    deviceid = phone + '_' + time + '_' + num;
    common.set('login_deviceid', deviceid);
  }
  return deviceid;
};
export default {
  detectmob,
  getClientHeight,
  getClientWidth,
  browserCoreFn,
  browserReachLevel,
  getElementStyle,
  formate_seconds,
  createDeviceId,
  getSystemInfo,
  getBrowserVersion,
  createUniqueId,
  messageFilter,
  clearMessageFilterData,
  realLength,
  getScreenInfomation,
  setNodeStorge,
  getNodeStorge,
  removeStorge,
  dateFormat,
  getLANIP,
  screenshotsVideo,
  downloadScreenshotsWeb,
  screenshotsPc,
  mkScreenshotsDir,
  issafariBrowser,
  setVideoWH,
  loadImage,
  createLoginDeviceId,
};



// WEBPACK FOOTER //
// ./src/js/utils.js